export default "__VITE_ASSET__7867d7e7__"